// FILE IS SORTED ALPHABETICALLY, PLEASE KEEP IT THAT WAY

const DIVISION = {
  CARDIAC: 'CARDIAC',
  COMMUNITY: 'COMMUNITY',
  CPC: 'CPC',
  CRITICAL_CARE: 'CRITICAL_CARE',
  CVICU: 'CVICU',
  CARDIAC_SURGERY: 'CARDIAC_SURGERY',
  DENTISTRY: 'DENTISTRY',
  EDUCATION: 'EDUCATION',
  ENDOCRINOLOGY: 'ENDOCRINOLOGY',
  GENERAL: 'GENERAL',
  GASTROENTEROLOGY: 'GASTROENTEROLOGY',
  HEMATOLOGY_ONCOLOGY: 'HEMATOLOGY_ONCOLOGY',
  LCSW: 'LCSW',
  LEADERSHIP: 'LEADERSHIP',
  LOCUM: 'LOCUM',
  OB: 'OB',
  PAIN: 'PAIN',
  PAT: 'PAT',
  PEDIATRIC: 'PEDIATRIC',
  PEDIATRIC_HEART: 'PEDIATRIC_HEART',
  PSYCHIATRY: 'PSYCHIATRY',
  RAAPS: 'RAAPS',
  PULMONOLOGY: 'PULMONOLOGY',
  RESEARCH: 'RESEARCH',
  TAR: 'TAR',
  TRAUMA: 'TRAUMA',
  VA: 'VA',
  LIVER: 'LIVER',
  NEPHROLOGY: 'NEPHROLOGY',
  NEURO_SPINE: 'NEURO_SPINE',
  ENDOSCOPY: 'ENDOSCOPY',
  REGIONAL: 'REGIONAL',
  INPATIENT: 'INPATIENT',
  INTENSIVE_CARE_NURSERY: 'INTENSIVE_CARE_NURSERY',
  INTERNAL_MEDICINE: 'INTERNAL_MEDICINE',
  INFECTIOUS_DISEASE: 'INFECTIOUS_DISEASE',
  PEDIATRIC_INTENSIVE_CARE_UNIT: 'PEDIATRIC_INTENSIVE_CARE_UNIT',
  VASCULAR_SURGERY: 'VASCULAR_SURGERY',
  GERIATRICS: 'GERIATRICS',
  RHEUMATOLOGY: 'RHEUMATOLOGY',
  TRANSPLANT: 'TRANSPLANT',
  PRE_ADMISSION_TESTING: 'PRE_ADMISSION_TESTING',
  MULTIDISCIPLINARY: 'MULTIDISCIPLINARY',
  QUALITY_SAFETY_INNOVATION: 'QUALITY_SAFETY_INNOVATION',
  THORACIC: 'THORACIC',
  VASCULAR_ANESTHESIA: 'VASCULAR_ANESTHESIA',
  ORTHOPEDIC: 'ORTHOPEDIC',
  NEURO_ICU: 'NEURO_ICU',
};

const SPECIALTY = {
  ADDICTION_MEDICINE: 'ADDICTION_MEDICINE',
  ADULT_ANESTHESIA: 'ADULT_ANESTHESIA',
  CARDIAC_ANESTHESIA: 'CARDIAC_ANESTHESIA',
  CRITICAL_CARE: 'CRITICAL_CARE',
  DENTISTRY: 'DENTISTRY',
  EDUCATION: 'EDUCATION',
  EMERGENCY_MEDICINE: 'EMERGENCY_MEDICINE',
  GENERAL_ANESTHESIA: 'GENERAL_ANESTHESIA',
  HEMATOLOGY_ONCOLOGY: 'HEMATOLOGY_ONCOLOGY',
  HOSPITAL_MEDICINE: 'HOSPITAL_MEDICINE',
  MCP: 'MCP',
  NEUROANESTHESIA: 'NEUROANESTHESIA',
  OBSTETRIC_ANESTHESIA: 'OBSTETRIC_ANESTHESIA',
  PALLIATIVE_CARE: 'PALLIATIVE_CARE',
  PAIN_MANAGEMENT: 'PAIN_MANAGEMENT',
  PRIMARY_CARE: 'PRIMARY_CARE',
  PEDIATRIC_ANESTHESIA: 'PEDIATRIC_ANESTHESIA',
  PEDIATRIC_CARDIAC_ANESTHESIA: 'PEDIATRIC_CARDIAC_ANESTHESIA',
  PEDIATRIC_PAIN_MANAGEMENT: 'PEDIATRIC_PAIN_MANAGEMENT',
  PSYCHOLOGY: 'PSYCHOLOGY',
  QUALITY: 'QUALITY',
  RAAPS: 'RAAPS',
  RESEARCH: 'RESEARCH',
  REGIONAL_ANESTHESIA: 'REGIONAL_ANESTHESIA',
  SIMULATION: 'SIMULATION',
  TRAUMA_ANESTHESIA: 'TRAUMA_ANESTHESIA',
  TRANSPLANT_ANESTHESIA: 'TRANSPLANT_ANESTHESIA',
  PODIATRIC_SURGERY: 'PODIATRIC_SURGERY',
};

const PROFESSIONS = {
  ACUPUNCTURIST: 'ACUPUNCTURIST',
  ADMINISTRATION: 'ADMINISTRATION',
  ANALYST_PROGRAMMER: 'ANALYST_PROGRAMMER',
  ANESTHESIA_TECHNOLOGIST: 'ANESTHESIA_TECHNOLOGIST',
  APP: 'APP',
  BTSA_III: 'BTSA_III',
  CAA: 'CAA',
  CAO: 'CAO',
  CRS_II: 'CRS_II',
  CHILD_LIFE: 'CHILD_LIFE',
  EDUCATION_MANAGER: 'EDUCATION_MANAGER',
  FINANCE_MANAGER: 'FINANCE_MANAGER',
  GENETIC_COUNSELOR: 'GENETIC_COUNSELOR',
  ICT_MANAGER: 'ICT_MANAGER',
  IT_SUPPORT: 'IT_SUPPORT',
  LAB_TECHNICIAN: 'LAB_TECHNICIAN',
  MEDICAL_DOCTOR: 'MEDICAL_DOCTOR',
  MSO: 'MSO',
  NURSE_ANESTHETIST: 'NURSE_ANESTHETIST',
  NURSE_PRACTITIONER: 'NURSE_PRACTITIONER',
  PARAMEDIC: 'PARAMEDIC',
  PHARMACY: 'PHARMACY',
  PHYSICIAN_SCHEDULER: 'PHYSICIAN_SCHEDULER',
  PHYSIOTHERAPIST: 'PHYSIOTHERAPIST',
  POST_DOC: 'POST_DOC',
  PSYCHOLOGIST: 'PSYCHOLOGIST',
  REGISTERED_DIETICIAN: 'REGISTERED_DIETICIAN',
  REGISTERED_NURSE: 'REGISTERED_NURSE',
  RESEARCHER: 'RESEARCHER',
  RESIDENCY_COORDINATOR: 'RESIDENCY_COORDINATOR',
  RESPIRATORY_THERAPIST: 'RESPIRATORY_THERAPIST',
  /**
   * @note "Skilled Caregiver" was renamed to "Clinical Assistant" in lang
   */
  SKILLED_CAREGIVER: 'SKILLED_CAREGIVER',
  SKILLED_TECHNICIAN: 'SKILLED_TECHNICIAN',
  SOCIAL_WORK: 'SOCIAL_WORK',
  STUDENT_PROFESSION: 'STUDENT_PROFESSION',
  CHAPLAIN: 'CHAPLAIN',
  OTHER: 'OTHER',
};

const ROLES_LOGISTICS = {
  EQUIPMENT_MANAGEMENT: 'EQUIPMENT_MANAGEMENT',
  PERIOPERATIVE_STAFF: 'PERIOPERATIVE_STAFF',
  SUPPLY_CHAIN: 'SUPPLY_CHAIN',
};

const ROLES_ADMINISTRATOR = {
  ADMINISTRATOR: 'ADMINISTRATOR',
  ADMINISTRATIVE_ASSISTANT: 'ADMINISTRATIVE_ASSISTANT',
  ADMINISTRATIVE_ASSISTANT_ANESTHETISTS: 'ADMINISTRATIVE_ASSISTANT_ANESTHETISTS',
  ADMINISTRATIVE_ASSISTANT_PEDIATRIC_DIVISION: 'ADMINISTRATIVE_ASSISTANT_PEDIATRIC_DIVISION',
  ADMINISTRATIVE_ASSOCIATE_CHAIR: 'ADMINISTRATIVE_ASSOCIATE_CHAIR',
  ADMINISTRATIVE_COORDINATOR: 'ADMINISTRATIVE_COORDINATOR',
  ADMINISTRATIVE_COORDINATOR_FINANCE: 'ADMINISTRATIVE_COORDINATOR_FINANCE',
  ADMINISTRATIVE_COORDINATOR_STAFFING_SCHEDULING: 'ADMINISTRATIVE_COORDINATOR_STAFFING_SCHEDULING',
  ASSOCIATE_DEPARTMENT_ADMINISTRATOR_OPERATIONS: 'ASSOCIATE_DEPARTMENT_ADMINISTRATOR_OPERATIONS',
  BUSINESS_OPERATIONS_COORDINATOR_PEDIATRIC_DIVISION:
    'BUSINESS_OPERATIONS_COORDINATOR_PEDIATRIC_DIVISION',
  BUSINESS_OPERATIONS_COORDINATOR_SR: 'BUSINESS_OPERATIONS_COORDINATOR_SR',
  CLINICAL_PROGRAM_COORDINATOR_II: 'CLINICAL_PROGRAM_COORDINATOR_II',
  CLINICAL_PROGRAM_COORDINATOR_III: 'CLINICAL_PROGRAM_COORDINATOR_III',
  COMMUNICATION_SPECIALIST: 'COMMUNICATION_SPECIALIST',
  CSG_ADMINISTRATOR_ANESTHESIOLOGY_AND_DIAGNOSTICS:
    'CSG_ADMINISTRATOR_ANESTHESIOLOGY_AND_DIAGNOSTICS',
  DEPARTMENT_ADMINISTRATOR: 'DEPARTMENT_ADMINISTRATOR',
  DIVISION_ADMINISTRATOR_I: 'DIVISION_ADMINISTRATOR_I',
  DIVISION_ADMINISTRATOR_III: 'DIVISION_ADMINISTRATOR_III',
  EDUCATION_PROGRAM_COORDINATOR_II_FELLOWS: 'EDUCATION_PROGRAM_COORDINATOR_II_FELLOWS',
  EDUCATION_PROGRAM_COORDINATOR_II_INTERNS: 'EDUCATION_PROGRAM_COORDINATOR_II_INTERNS',
  EDUCATION_PROGRAM_COORDINATOR_II_RESIDENTS: 'EDUCATION_PROGRAM_COORDINATOR_II_RESIDENTS',
  EDUCATION_PROGRAM_COORDINATOR_III_MSA: 'EDUCATION_PROGRAM_COORDINATOR_III_MSA',
  INSTRUCTOR: 'INSTRUCTOR',
  LOGISTICS_OPERATIONS: 'LOGISTICS_OPERATIONS',
  PROGRAM_COORDINATOR_II_EDUCATION_DIVISION: 'PROGRAM_COORDINATOR_II_EDUCATION_DIVISION',
  PROGRAM_MANAGER_MSA: 'PROGRAM_MANAGER_MSA',
  PROGRAM_MANAGER_QUALITY: 'PROGRAM_MANAGER_QUALITY',
  PROGRAM_MANAGER_SPECIALTY_DIVISIONS: 'PROGRAM_MANAGER_SPECIALTY_DIVISIONS',
  RESIDENT_LEARNER_COORDINATOR: 'RESIDENT_LEARNER_COORDINATOR',
  SUPPORT_STAFF: 'SUPPORT_STAFF',
  UNIT_EXECUTIVE_ADMINISTRATOR: 'UNIT_EXECUTIVE_ADMINISTRATOR',
  UNIT_FINANCE_DIRECTOR: 'UNIT_FINANCE_DIRECTOR',
  ...ROLES_LOGISTICS,
};

const ROLES_APP = {
  ADVANCED_PRACTICE_NURSE: 'ADVANCED_PRACTICE_NURSE',
  NURSE_PRACTITIONER: 'NURSE_PRACTITIONER',
  PHYSICIAN_ASSISTANT: 'PHYSICIAN_ASSISTANT',
  PHYSICIAN_ASSISTANT_SURGICAL: 'PHYSICIAN_ASSISTANT_SURGICAL',
  SOCIAL_WORKER_PAIN_MANAGEMENT: 'SOCIAL_WORKER_PAIN_MANAGEMENT',
  MIDWIFE: 'MIDWIFE',
};

const ROLES_CAA = {
  ASSISTANT_PROFESSOR: 'ASSISTANT_PROFESSOR',
  CERTIFIED_ANESTHESIOLOGIST_ASSISTANT: 'CERTIFIED_ANESTHESIOLOGIST_ASSISTANT',
  CHIEF_ANESTHETIST: 'CHIEF_ANESTHETIST',
  CHIEF_CAA: 'CHIEF_CAA',
  CRNA: 'CRNA',
  CAA: 'CAA',
  FACULTY_INSTRUCTOR: 'FACULTY_INSTRUCTOR',
  MSA_STUDENT: 'MSA_STUDENT',
  STAFF_CAA: 'STAFF_CAA',
};

const ROLES_CRNA = {
  CHIEF_ANESTHETIST: 'CHIEF_ANESTHETIST',
  CHIEF_CRNA: 'CHIEF_CRNA',
  CRNA: 'CRNA',
  CRNA_ASSISTANT_CHIEF: 'CRNA_ASSISTANT_CHIEF',
  CRNA_CHIEF: 'CRNA_CHIEF',
  CRNA_LOCUM: 'CRNA_LOCUM',
  CRNA_OPT: 'CRNA_OPT',
  DNP_CRNA: 'DNP_CRNA',
  LOCUM: 'LOCUM',
  SRNA: 'SRNA',
  STAFF_CRNA: 'STAFF_CRNA',
};

const ROLES_DOCTOR = {
  ADJUNCT_ASSISTANT_PROFESSOR: 'ADJUNCT_ASSISTANT_PROFESSOR',
  ASSISTANT_PROFESSOR: 'ASSISTANT_PROFESSOR',
  ASSISTANT_PROFESSOR_EMERGENCY_MEDICINE_CRITICAL_CARE:
    'ASSISTANT_PROFESSOR_EMERGENCY_MEDICINE_CRITICAL_CARE',
  ASSISTANT_PROFESSOR_PHYSICAL_MEDICINE_REHABILITATION_PAIN_MANAGEMENT:
    'ASSISTANT_PROFESSOR_PHYSICAL_MEDICINE_REHABILITATION_PAIN_MANAGEMENT',
  ASSOCIATE_PROFESSOR: 'ASSOCIATE_PROFESSOR',
  ATTENDING_PHYSICIAN: 'ATTENDING_PHYSICIAN',
  BASIC_SCIENCE_FACULTY: 'BASIC_SCIENCE_FACULTY',
  CHIEF_PHISICIAN: 'CHIEF_PHISICIAN',
  CLINICAL_ASSOCIATE_PROFESSOR: 'CLINICAL_ASSOCIATE_PROFESSOR',
  CLINICAL_ASSISTANT_PROFESSOR: 'CLINICAL_ASSISTANT_PROFESSOR',
  CLINICAL_PROFESSOR: 'CLINICAL_PROFESSOR',
  CLINICAL_SENIOR_INSTRUCTOR: 'CLINICAL_SENIOR_INSTRUCTOR',
  VICE_CHIEF_PHYSICIAN: 'VICE_CHIEF_PHYSICIAN',
  CHIEF_RESIDENT: 'CHIEF_RESIDENT',
  DEPARTMENT_CHAIR: 'DEPARTMENT_CHAIR',
  DEPARTMENT_CHAIR_AND_JOHN_P_KAMPINE_PROFESSOR_OF_ANESTHESIOLOGY:
    'DEPARTMENT_CHAIR_AND_JOHN_P_KAMPINE_PROFESSOR_OF_ANESTHESIOLOGY',
  FACULTY_PHYSICIAN: 'FACULTY_PHYSICIAN',
  FELLOW: 'FELLOW',
  INSTRUCTOR_FELLOW: 'INSTRUCTOR_FELLOW',
  INTERN: 'INTERN',
  INSTRUCTOR: 'INSTRUCTOR',
  LOCUM: 'LOCUM',
  LOCUM_TENENS: 'LOCUM_TENENS',
  MEDICAL_STUDENT: 'MEDICAL_STUDENT',
  MEDICAL_DIRECTOR: 'MEDICAL_DIRECTOR',
  MSP: 'MSP',
  PROFESSOR: 'PROFESSOR',
  PROFESSOR_EMERITUS: 'PROFESSOR_EMERITUS',
  RESIDENT: 'RESIDENT',
  STAFF_PHYSICIAN: 'STAFF_PHYSICIAN',
  TAR: 'TAR',
};

const ROLES_FACULTY = {
  ADJUNCT_PROFESSOR: 'ADJUNCT_PROFESSOR',
  ASSISTANT_PROFESSOR: 'ASSISTANT_PROFESSOR',
  ASSOCIATE_PROFESSOR: 'ASSOCIATE_PROFESSOR',
  CLINICAL_ASSISTANT_PROFESSOR: 'CLINICAL_ASSISTANT_PROFESSOR',
  PROFESSOR: 'PROFESSOR',
  PROFESSOR_EMERITUS: 'PROFESSOR_EMERITUS',
};

const ROLES_NURSE = {
  CERTIFIED_NURSE: 'CERTIFIED_NURSE',
  CHARGE_NURSE: 'CHARGE_NURSE',
  CLINIC_NURSE: 'CLINIC_NURSE',
  HEAD_NURSE: 'HEAD_NURSE',
  LOCUM_NURSE: 'LOCUM_NURSE',
  NURSE_EDUCATOR: 'NURSE_EDUCATOR',
  NURSE_SUPERVISOR: 'NURSE_SUPERVISOR',
  QA_NURSE: 'QA_NURSE',
  RESEARCHER: 'RESEARCHER',
  SCREENING_NURSE: 'SCREENING_NURSE',
  SPECIALISED_NURSE: 'SPECIALISED_NURSE',
  STUDENT_NURSE: 'STUDENT_NURSE',
  TAH: 'TAH',
  TAR_NURSE: 'TAR_NURSE',
  TRAINEE_NURSE: 'TRAINEE_NURSE',
  STAFF_NURSE: 'STAFF_NURSE',
  TRAVEL_NURSE: 'TRAVEL_NURSE',
};

const ROLES_PARAMEDIC = {
  CERTIFIED_PARAMEDIC: 'CERTIFIED_PARAMEDIC',
  HEAD_PARAMEDIC: 'HEAD_PARAMEDIC',
  STUDENT: 'STUDENT',
  TRAINEE_PARAMEDIC: 'TRAINEE_PARAMEDIC',
};

const ROLES_RESEARCHER = {
  ADMINISTRATIVE_ASSISTANT_SR: 'ADMINISTRATIVE_ASSISTANT_SR',
  ASSISTANT: 'ASSISTANT',
  CLINICAL_RESEARCH_ASSISTANT_III: 'CLINICAL_RESEARCH_ASSISTANT_III',
  CLINICAL_RESEARCH_COORDINATOR_II: 'CLINICAL_RESEARCH_COORDINATOR_II',
  ENGINEER_II: 'ENGINEER_II',
  FACULTY: 'FACULTY',
  GRADUATE_STUDENT: 'GRADUATE_STUDENT',
  LAB_MANAGER: 'LAB_MANAGER',
  LAB_SUPERVISOR: 'LAB_SUPERVISOR',
  LABORATORY_COORDINATOR: 'LABORATORY_COORDINATOR',
  POSTDOCTORAL_FELLOW: 'POSTDOCTORAL_FELLOW',
  PROGRAM_MANAGER_RESEARCH: 'PROGRAM_MANAGER_RESEARCH',
  PROJECT_APPOINTMENT_STUDENT: 'PROJECT_APPOINTMENT_STUDENT',
  RESEARCH_ASSOCIATE_I: 'RESEARCH_ASSOCIATE_I',
  RESEARCH_GRANTS_COORDINATOR: 'RESEARCH_GRANTS_COORDINATOR',
  RESEARCH_SCIENTIST: 'RESEARCH_SCIENTIST',
  RESEARCH_SCIENTIST_I: 'RESEARCH_SCIENTIST_I',
  RESEARCH_SCIENTIST_II: 'RESEARCH_SCIENTIST_II',
  RESEARCH_TECH_II: 'RESEARCH_TECH_II',
  RESEARCH_TECH_III: 'RESEARCH_TECH_III',
  RESEARCH_TECHNOLOGIST_I: 'RESEARCH_TECHNOLOGIST_I',
  SUPERVISOR_LAB: 'SUPERVISOR_LAB',
  RESEARCH_OPERATIONS_MANAGER: 'RESEARCH_OPERATIONS_MANAGER',
  UNIT_EDUCATION_MANAGER: 'UNIT_EDUCATION_MANAGER',
  POSTDOCTORAL_RESEARCHER: 'POSTDOCTORAL_RESEARCHER',
  ...ROLES_FACULTY,
};

const ROLES_RESPIRATORY_THERAPIST = {
  STAFF_RESPIRATORY_THERAPIST: 'STAFF_RESPIRATORY_THERAPIST',
  RESPIRATORY_THERAPIST_MANAGER: 'RESPIRATORY_THERAPIST_MANAGER',
  RESPIRATORY_THERAPIST_THERAPY: 'RESPIRATORY_THERAPIST_THERAPY',
};

const ROLES_SOCIAL_WORK = {
  SOCIAL_WORKER: 'SOCIAL_WORKER',
};

const ROLES_SKILLED_TECHNICIAN = {
  ANESTHESIA_TECHNICIAN: 'ANESTHESIA_TECHNICIAN',
  CARDIOTECHNICIAN: 'CARDIOTECHNICIAN',
  MEDICAL_ASSISTANT: 'MEDICAL_ASSISTANT',
  OPERATING_ROOM_INSTRUMENTALIST: 'OPERATING_ROOM_INSTRUMENTALIST',
};

const ROLES_PHARMACY = {
  PHARMACIST: 'PHARMACIST',
};

/**
 * @note profession "Skilled Caregiver" was renamed to "Clinical Assistant" in lang
 */
const ROLES_SKILLED_CAREGIVER = {
  UNIT_SUPPORT_ASSITANT: 'UNIT_SUPPORT_ASSITANT',
  LICENSED_NURSING_ASSISTANT: 'LICENSED_NURSING_ASSISTANT',
};

const ROLES_STUDENT = {
  UNDERGRADUATE: 'UNDERGRADUATE',
  GRADUATE: 'GRADUATE',
  MEDICAL: 'MEDICAL',
  NURSING: 'NURSING',
};

const ROLES_ALL = {
  ...ROLES_ADMINISTRATOR,
  ...ROLES_APP,
  ...ROLES_CAA,
  ...ROLES_DOCTOR,
  ...ROLES_CRNA,
  ...ROLES_NURSE,
  ...ROLES_PARAMEDIC,
  ...ROLES_RESEARCHER,
  ...ROLES_RESPIRATORY_THERAPIST,
  ...ROLES_SOCIAL_WORK,
  ...ROLES_SKILLED_TECHNICIAN,
  ...ROLES_PHARMACY,
  ...ROLES_SKILLED_CAREGIVER,
  ...ROLES_STUDENT,
};

const ROLES_BY_PROFESSION = new Map([
  [PROFESSIONS.ADMINISTRATION, Object.values(ROLES_ADMINISTRATOR)],
  [PROFESSIONS.APP, Object.values(ROLES_APP)],
  [PROFESSIONS.CAA, Object.values(ROLES_CAA)],
  [PROFESSIONS.NURSE_ANESTHETIST, Object.values(ROLES_CRNA)],
  [PROFESSIONS.REGISTERED_NURSE, Object.values(ROLES_NURSE)],
  [PROFESSIONS.MEDICAL_DOCTOR, Object.values(ROLES_DOCTOR)],
  [PROFESSIONS.PARAMEDIC, Object.values(ROLES_PARAMEDIC)],
  [PROFESSIONS.RESEARCHER, Object.values(ROLES_RESEARCHER)],
  [PROFESSIONS.RESPIRATORY_THERAPIST, Object.values(ROLES_RESPIRATORY_THERAPIST)],
  [PROFESSIONS.SOCIAL_WORK, Object.values(ROLES_SOCIAL_WORK)],
  [PROFESSIONS.SKILLED_TECHNICIAN, Object.values(ROLES_SKILLED_TECHNICIAN)],
  [PROFESSIONS.PHARMACY, Object.values(ROLES_PHARMACY)],
  [PROFESSIONS.SKILLED_CAREGIVER, Object.values(ROLES_SKILLED_CAREGIVER)],
  [PROFESSIONS.STUDENT_PROFESSION, Object.values(ROLES_STUDENT)],
]);

const TRAINING_LEVELS_MEDICAL_STUDENT = {
  MED1: 'MED1',
  MED2: 'MED2',
  MED3: 'MED3',
  MED4: 'MED4',
  MED5: 'MED5',
  MED6: 'MED6',
};

const TRAINING_LEVELS_RESIDENT = {
  CA_1: 'CA_1',
  CA_2: 'CA_2',
  CA_3: 'CA_3',
  PGY_1: 'PGY_1',
  PGY_2: 'PGY_2',
  PGY_3: 'PGY_3',
  PGY_4: 'PGY_4',
  PGY_5: 'PGY_5',
  PGY_6: 'PGY_6',
  PGY_7: 'PGY_7',
};

const TRAINING_LEVELS_SRNA = {
  SRNA_1: 'SRNA_1',
  SRNA_2: 'SRNA_2',
  SRNA_3: 'SRNA_3',
};

const TRAINING_LEVELS_ALL = {
  ...TRAINING_LEVELS_MEDICAL_STUDENT,
  ...TRAINING_LEVELS_RESIDENT,
  ...TRAINING_LEVELS_SRNA,
};

const LEVEL_OF_TRAINING_BY_ROLE = new Map([
  [ROLES_ALL.MEDICAL_STUDENT, Object.values(TRAINING_LEVELS_MEDICAL_STUDENT)],
  [ROLES_ALL.RESIDENT, Object.values(TRAINING_LEVELS_RESIDENT)],
  [ROLES_ALL.SRNA, Object.values(TRAINING_LEVELS_SRNA)],
]);

const PROFESSIONS_WITH_ROLES = [PROFESSIONS.MEDICAL_DOCTOR, PROFESSIONS.REGISTERED_NURSE];
const ROLES_WITH_LEVEL_OF_TRAINING = [
  ROLES_ALL.MEDICAL_STUDENT,
  ROLES_ALL.RESIDENT,
  ROLES_ALL.SRNA,
];

const LANGUAGES = {
  DE: 'DE',
  EN: 'EN',
  FR: 'FR',
  IT: 'IT',
};

const USER_TAGS_KEYS = {
  DEPARTMENT: 'department',
  LEVEL_OF_TRAINING: 'levelOfTraining',
  PROFESSION: 'profession',
  ROLE: 'role',
  ROTATION: 'rotation',
  DIVISION: 'division',
  LOCATION: 'location',
  SPECIALTY: 'specialty',
  PERMISSIONS: 'permissions',
  // support for notify team
  USERS: 'users',
};

export {
  DIVISION,
  SPECIALTY,
  PROFESSIONS,
  ROLES_ALL,
  ROLES_ADMINISTRATOR,
  ROLES_APP,
  ROLES_CAA,
  ROLES_DOCTOR,
  ROLES_CRNA,
  ROLES_NURSE,
  ROLES_PARAMEDIC,
  ROLES_RESEARCHER,
  ROLES_RESPIRATORY_THERAPIST,
  ROLES_SOCIAL_WORK,
  ROLES_SKILLED_TECHNICIAN,
  ROLES_PHARMACY,
  ROLES_SKILLED_CAREGIVER,
  ROLES_STUDENT,
  TRAINING_LEVELS_MEDICAL_STUDENT,
  TRAINING_LEVELS_RESIDENT,
  TRAINING_LEVELS_SRNA,
  TRAINING_LEVELS_ALL,
  LANGUAGES,
  USER_TAGS_KEYS,
  PROFESSIONS_WITH_ROLES,
  ROLES_WITH_LEVEL_OF_TRAINING,
  LEVEL_OF_TRAINING_BY_ROLE,
  ROLES_BY_PROFESSION,
};
